import { actionCreator } from 'utils';
import * as PackageTypes from '../types/packageTypes';

const listingConfigurations = {
    loading: false,
    error: false,
    listing: [],
    offset: 0,
    limit: 10,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    filters: {
        'configuration_property.carrier_id': [],
        'configuration_property.property_value_id': [],
        configuration_type: [],
        'name.translate': '',
    },
    checked: [],
};

const initState = {
    loading: false,
    error: false,
    listing: null,
    offset: 0,
    limit: 30,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    filters: {
        name: '',
        created_by: [],
        configurations: [],
    },
    add: {
        loading: false,
        error: false,
    },
    edit: {
        loading: false,
        error: false,
        data: null,
        configurations: {
            new: [],
            deleted: [],
        },
    },
    bulk: {
        current: 0,
        cartesians: [],
        loading: false,
        error: false,
        finish: false,
        progress: [],
    },
    statusLoading: null,
    pickConfigurations: listingConfigurations,
    primaryConfigurations: { ...listingConfigurations, limit: 10 },
    appliedOptions: { ...listingConfigurations, limit: 10 },
};

export default function (state = initState, action) {
    switch (action.type) {
    case PackageTypes.LOAD_PACKAGES:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(PackageTypes.LOAD_PACKAGES, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(PackageTypes.LOAD_PACKAGES, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case PackageTypes.SET_PACKAGE_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case PackageTypes.SET_PACKAGE_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case PackageTypes.SET_PACKAGE_FILTER:
        return Object.assign({}, state, {
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case PackageTypes.RESET_PACKAGE_FILTERS:
        return Object.assign({}, state, {
            filters: initState.filters,
        });

    case PackageTypes.LOAD_CONFIGURATIONS_FOR_PACKAGE:
        return Object.assign({}, state, {
            [action.prop]: Object.assign({}, state[action.prop], {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(PackageTypes.LOAD_CONFIGURATIONS_FOR_PACKAGE, 'res'):
        return Object.assign({}, state, {
            [action.prop]: Object.assign({}, state[action.prop], {
                loading: false,
                listing: action.data,
            }),
        });

    case actionCreator(PackageTypes.LOAD_CONFIGURATIONS_FOR_PACKAGE, 'err'):
        return Object.assign({}, state, {
            [action.prop]: Object.assign({}, state[action.prop], {
                loading: false,
                error: true,
            }),
        });

    case PackageTypes.SET_CONFIGURATION_FILTER_FOR_PACKAGE:
        return Object.assign({}, state, {
            [action.prop]: Object.assign({}, state[action.prop], {
                loading: true,
                filters: {
                    ...state[action.prop].filters,
                    [action.key]: action.value,
                },
            }),
        });

    case actionCreator(PackageTypes.SET_CONFIGURATION_FILTER_FOR_PACKAGE, 'res'):
        return Object.assign({}, state, {
            [action.prop]: Object.assign({}, state[action.prop], {
                loading: false,
                listing: action.data,
            }),
        });

    case PackageTypes.SET_CONFIGURATION_PAGINATION_FOR_PACKAGE:
        return Object.assign({}, state, {
            [action.prop]: Object.assign({}, state[action.prop], {
                [action.key]: action.pagination,
            }),
        });

    case PackageTypes.SET_CONFIGURATION_SORT_FOR_PACKAGE:
        return Object.assign({}, state, {
            [action.prop]: Object.assign({}, state[action.prop], {
                sort: action.sort,
            }),
        });

    case PackageTypes.RESET_CONFIGURATION_FILTERS_FOR_PACKAGE:
        return Object.assign({}, state, {
            [action.prop]: Object.assign({}, state[action.prop], {
                filters: {
                    'configuration_property.carrier_id': [],
                    'configuration_property.property_value_id': [],
                    configuration_type: [],
                    'name.translate': '',
                },
            }),
        });

    case PackageTypes.SET_CHECKED_CONFIGURATIONS_FOR_PACKAGE:
        return Object.assign({}, state, {
            [action.prop]: Object.assign({}, state[action.prop], {
                checked: action.ids,
            }),
        });

    case PackageTypes.ADD_NEW_PACKAGE:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(PackageTypes.ADD_NEW_PACKAGE, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: false,
            }),
        });

    case actionCreator(PackageTypes.ADD_NEW_PACKAGE, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: false,
                error: action.error,
            }),
        });

    case PackageTypes.GO_TO_ADD_BULK_PACKAGES_STEP:
        return Object.assign({}, state, {
            bulk: Object.assign({}, state.bulk, {
                current: action.step,
            }),
        });

    case PackageTypes.ADD_TO_BULK_CARTESIANS:
        return Object.assign({}, state, {
            bulk: Object.assign({}, state.bulk, {
                cartesians: action.packages,
            }),
        });

    case PackageTypes.ADD_BULK_PACKAGES:
        return Object.assign({}, state, {
            bulk: Object.assign({}, state.bulk, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(PackageTypes.ADD_BULK_PACKAGES, 'res'):
        return Object.assign({}, state, {
            bulk: Object.assign({}, state.bulk, {
                loading: false,
                ...initState.bulk,
            }),
        });

    case actionCreator(PackageTypes.ADD_BULK_PACKAGES, 'err'):
        return Object.assign({}, state, {
            bulk: Object.assign({}, state.bulk, {
                loading: false,
                error: action.error,
            }),
        });

    case PackageTypes.UPDATE_PROGRESS_OF_BULK_PACKAGES:
        return Object.assign({}, state, {
            bulk: {
                ...state.bulk,
                finish: false,
                progress: [
                    ...state.bulk.progress,
                    action.data,
                ],
            },
        });

    case PackageTypes.FINISH_ADDING_BULK_PACKAGES:
        return Object.assign({}, state, {
            bulk: {
                ...state.bulk,
                loading: false,
                finish: true,
                progress: [],
            },
        });

    case PackageTypes.LOAD_EDITABLE_PACKAGE:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(PackageTypes.LOAD_EDITABLE_PACKAGE, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(PackageTypes.LOAD_EDITABLE_PACKAGE, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case PackageTypes.EDIT_PACKAGE:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(PackageTypes.EDIT_PACKAGE, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: null,
            }),
        });

    case actionCreator(PackageTypes.EDIT_PACKAGE, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: action.error,
            }),
        });

    case PackageTypes.SET_EMPTY_EDITABLE_PACKAGE:
        return Object.assign({}, state, {
            edit: initState.edit,
        });

    case PackageTypes.SET_CONFIGURATIONS_TO_EDITABLE_PACKAGE:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                configurations: {
                    ...state.edit.configurations,
                    [action.key]: action.value,
                },
            }),
        });

    case PackageTypes.TOGGLE_PACKAGE_STATUS:
        return Object.assign({}, state, {
            statusLoading: action.id,
        });

    case actionCreator(PackageTypes.TOGGLE_PACKAGE_STATUS, 'res') || actionCreator(PackageTypes.TOGGLE_PACKAGE_STATUS, 'err'):
        return Object.assign({}, state, {
            statusLoading: null,
        });

    default:
        return state;
    }
}
